import { Mark } from 'tiptap';
import { updateMark } from 'tiptap-commands';

export default class FontColor extends Mark {
  get name() {
    return 'color';
  }

  get schema() {
    return {
      attrs: {
        color: {
          default: '',
        },
      },
      content: 'inline*',
      group: 'block',
      draggable: false,
      parseDOM: [{
        style: 'color',
        getAttrs: (mark) => ({ color: mark }),
      }],
      toDOM: (mark) => ['span', { style: `color: ${mark.attrs.color}` }, 0],
    };
  }

  commands({ type }) {
    return (attrs) => updateMark(type, attrs);
  }
}
